export const SOURCE_TYPE = {
  MENTION: 'mention',
  LINK: 'link',
}
